module.exports = __webpack_public_path__ + "static/media/educat.d02909c3.png";